import React from 'react';

const BilingualQuestion = ({step,  french, english, islast }) => {
    return (
      <div style={{marginBottom: "20px", textAlign : islast ? 'center' : 'left' }}>
        <p style={{ fontSize: "20px", margin: "0", fontWeight: "bold", color: "#DECFC8", 
          fontFamily: "'Louize', serif",}}>
         {step !== 0 && !islast && (<><span style={{fontSize:23}}>{`${step }`}</span>{'.  '}</>)}{`${french}`.toUpperCase()}
        </p>
        <p style={{ fontSize: "18px", margin: "0", color: "#DECFC8", 
          fontFamily: "'Louize', serif",fontStyle: "italic" }}> 
          {english.toLowerCase()}
        </p>
      </div>
    );
  };
export default BilingualQuestion